// extracted by mini-css-extract-plugin
export default {"tooltip":"EllipsedLabel_tooltip__ynuC4","lineClamp":"EllipsedLabel_lineClamp__1joqP"};